import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PipesModule } from 'src/app/core/pipes/pipes.module';
import { UploadReqTransactionCandidatesModalComponent } from './upload-req-transaction-candidates-modal.component';

@NgModule({
  declarations: [UploadReqTransactionCandidatesModalComponent],
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    PopoverModule.forRoot(),
    TooltipModule.forRoot(),
    PipesModule
  ],
  exports: [UploadReqTransactionCandidatesModalComponent],
  entryComponents: [UploadReqTransactionCandidatesModalComponent]
})
export class UploadReqTransactionCandidatesModalModule { }
